import { Rating, RatingProps } from "react-simple-star-rating";

import styles from "./styles.module.scss";

interface IRatingIconProps extends RatingProps {
  changeRating?: () => void;
  size?: number;
}
export const RatingIcon = (props: IRatingIconProps) => {
  const { changeRating, size } = props;
  return (
    <Rating
      emptyIcon={
        <img
          className={styles["raiting_star"]}
          alt="img"
          src="/assets/images/svg/starRating.svg"
          style={
            size
              ? { width: `${size}px`, height: `${size}px` }
              : { width: "14px", height: "14px" }
          }
        />
      }
      fillIcon={
        <img
          className={styles["raiting_star"]}
          alt="img"
          src="/assets/images/svg/starRatingFill.svg"
          style={
            size
              ? { width: `${size}px`, height: `${size}px` }
              : { width: "14px", height: "14px" }
          }
        />
      }
      allowFraction
      rtl={true}
      onClick={changeRating}
      className={styles["rating_container"]}
      {...props}
    />
  );
};
